import {forwardRef, useCallback, useEffect, useState} from 'react';
import cx from 'classnames';
import {Typography} from '~library/atoms/Typography';
import {FlipIcon} from '~library/svg/FlipIcon';
import {webviewFlipCard} from './webviewMessages';

import './FlipCard.sass';

export const FlipCard = forwardRef(({CardFront, CardBack}, ref) => {
  const [flipped, setFlipped] = useState(false);

  const onCardFlip = useCallback(() => {
    setFlipped((isFlipped) => !isFlipped);
    webviewFlipCard();
  }, [flipped]);

  useEffect(() => {
    if (ref.current) {
      // eslint-disable-next-line no-param-reassign
      ref.current.setCardFlipped = (value) => setFlipped(value);
    }
  }, [!!ref.current]);

  return (
    <div ref={ref} className={cx('flip-card', {flipped})}>
      <button
        className="flip-card__button"
        onClick={onCardFlip}
        data-qa-id="flip-card"
        type="button"
      >
        <FlipIcon ratio={0.7} color="#5352EB" />
        <Typography
          as="span"
          variant="link"
          size="medium"
          data-qa-id="flipCardText"
          color="tanzanite"
        >
          Flip card
        </Typography>
      </button>
      <div
        className="flip-card-inner"
        onClick={onCardFlip}
        onKeyUp={null}
        role="button"
        tabIndex={0}
        aria-label="flip-card"
      >
        <div className="flip-card-front">
          <CardFront />
        </div>
        <div className="fabric_user_card flip-card-back">
          <CardBack />
        </div>
      </div>
    </div>
  );
});
